// Decorative images must not flood the API when a directory page renders.
const MAX_CONCURRENT_LOGOS = 2;
const pending = [];
let active = 0;

function pump() {
  while (active < MAX_CONCURRENT_LOGOS && pending.length) {
    const job = pending.shift();
    active += 1;
    job.started = true;
    job.start();
  }
}

export function enqueueLogo(start) {
  const job = { start, started: false, finished: false };
  pending.push(job);
  pump();
  // Also cancel queued work when its component leaves the page.
  return () => {
    if (job.finished) return;
    job.finished = true;
    if (job.started) active -= 1;
    else pending.splice(pending.indexOf(job), 1);
    pump();
  };
}
